<template>
    <section v-if="$role.restricAccess($route.name, 'view')">
        <breadcrumb-template :headtitle="$route.meta.title" :breadcrumbcurrent="$route.meta.title"></breadcrumb-template>
        <v-card class="card-outline force-remove-box">
            <v-card-text class="force-custom-bg">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <v-tabs v-model="tab" grow>
                                <v-tab @click="getDataFromApi('latest')">Latest</v-tab>
                                <v-tab @click="getDataFromApi('all')">All</v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item class="p-5">
                                    <v-textarea outlined v-model="datas" :loading="is_loading" :auto-grow="true"></v-textarea>
                                </v-tab-item>

                                <v-tab-item class="p-5">
                                    <v-row>
                                        <v-col cols="12" lg="3" :class="($vuetify.breakpoint.mobile) ? 'mb-6':''">
                                            <player-autocomplete-template ref="player_autocomplete" filtertype="bethistory"></player-autocomplete-template>
                                        </v-col>
                                        <v-col cols="12" lg="3">
                                            <v-select hide-details outlined dense clearable :items="drawlist" item-value="id" item-text="name" label="Draw" v-model="filter.draw" multiple>
                                                <template v-slot:selection="{ item, index }">
                                                    <v-chip v-if="index === 0" small>
                                                        <span>{{ item.name }}</span>
                                                    </v-chip>
                                                    <span v-if="index === 1" class="grey--text text-caption">(+{{ filter.draw.length - 1 }})</span>
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" lg="1"><v-btn block color="custom_success" @click="getDataFromApi('all')">Search</v-btn></v-col>
                                        <v-col cols="12">
                                            <v-textarea outlined v-model="datas" :loading="is_loading" :auto-grow="true"></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

    </section>
</template>

<script>
    export default {
        data(){
            return{
                tab: 0,
                datas: null,
                is_loading: false,
                drawlist: [],
                filter: {
                    type: null,
                    draw: null,
                    player: null,
                },
            };
        },
        methods:{
            copyClipboard(data){
                data = data.split(' / ');
                // await navigator.clipboard.writeText(data[1]);
                // document.execCommand('copy');
                // this.$toast.fire({ icon: 'error', title: "TEST" });
                //   alert('Copied');
                // this.$Fire.$emit('betdialogbox');
                // this.$router.push({name: 'bet_add'});
            },
            getDataFromApi(val){

                let player = null;
                try {
                    if(this.$refs.player_autocomplete.autocomplete_model.id){
                        player = this.$refs.player_autocomplete.autocomplete_model.id;
                    }
                } catch (error) { player = null; }

                this.filter.type = val;
                this.filter.player = player;

                this.is_loading = true;
                this.$axios.post(this.$_CONFIG.api('API_RETURNS'), {filter: this.filter})
                    .then((data) => {
                        this.datas = data.data;
                        this.is_loading = false;
                    })
                    .catch((error) => {
                        this.is_loading = false;
                        this.$toast.fire({ icon: 'error', title: "Something went wrong!" });
                    });
            },
            getdrawlist(){
                this.$axios.get( this.$_CONFIG.api('API_DRAW_DROPDOWN'))
                .then(res => {
                    this.drawlist = res.data;
                })
                .catch(err => {
                    console.log(err)
                });
            },
        },
        created(){
            this.getDataFromApi('latest');
            this.getdrawlist();
        },
        mounted() {
        }
    }
</script>
<style scoped>

</style>
